import { SolEstimateTableRowBaseExtendedSubContractor } from './../../../models/sol-estimate-table/SolEstimateSubContractorCostsRow';
import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { SolEstimateTableSubContractorsCosts } from '../../../models/sol-estimate-table/SolEstimateTableSubContractorsCosts'
import { SolEstimatePricingMode } from '../../../models/enum';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MultilingualCurrencyPipe } from "../../../pipes/multilingual-currency-pipe/multilingual-currency.pipe";
import { MatInputModule } from '@angular/material/input';
import { NumericMaskDirective } from '../../../shared/numeric/numeric-mask.directive';
import { DecimalPrecisionPipe } from "../../../pipes/decimal-precision-pipe/decimal-precision.pipe";
import { CommonDataService } from '../../../services/common-data.service';
import { EstimateTab } from '../../../models/dtos';
import { SubcontractorSellPriceFlag, getSubcontractorSellPriceFlag } from '../../../services/estimate/estimate-last-modified-sell-price.service';
import { SolEstimateTableCommonFunctionsService } from '../../../services/sol-estimate-table-common-functions/sol-estimate-table-common-functions.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-sol-estimate-table-subcontractors-costs',
  imports: [
    MatIconModule,
    MatButtonModule,
    CommonModule,
    TranslatePipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NumericMaskDirective,
    MultilingualCurrencyPipe,
    DecimalPrecisionPipe
  ],
  templateUrl: './sol-estimate-table-subcontractors-costs.component.html',
  styleUrl: './sol-estimate-table-subcontractors-costs.component.scss'
})
export class SolEstimateTableSubcontractorsCostsComponent implements OnInit, OnDestroy {

  @Input() isMarkUpSelected: boolean = false;
  @Input() sellAsPricingMode: SolEstimatePricingMode = SolEstimatePricingMode.Line_Item;
  @Input() subContractorsCostsFormGroup: FormGroup<SolEstimateTableSubContractorsCosts>;

  isSubcontractorsCostsExpanded: boolean = false;
  solEstimatePricingMode = SolEstimatePricingMode;

  /** Live EstimateTab, read directly by the template so flag updates are picked up in place. */
  estimateTab: EstimateTab | null = null;

  /** Map of row index → flag name for sell-price highlighting. */
  sellPriceFlagsByIndex: Record<number, SubcontractorSellPriceFlag> = {};

  destroy$: Subject<void> = new Subject<void>();

  constructor(private readonly commonDataService: CommonDataService,
    public readonly solEstimateTableCommonFunctionsService: SolEstimateTableCommonFunctionsService) { }

  ngOnInit(): void {
    this.commonDataService.projectObjectDataAvailable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isAvailable: boolean) => {
        if (isAvailable) {
          this.estimateTab = this.commonDataService.getEstimateMetaData()?.estimateTab ?? null;
          this.buildSellPriceFlagMap();
        }
      });
  }

  /**
   * Pre-computes the sell-price flag names for each subcontractor row by index.
   * Allows template to access flags without calling a method (avoiding change detection calls).
   */
  private buildSellPriceFlagMap(): void {
    const rows = this.subContractorsCostsFormGroup.controls.subContractorsCostsRow;
    if (!rows) {
      return;
    }

    for (let i = 0; i < rows.length; i++) {
      this.sellPriceFlagsByIndex[i] = getSubcontractorSellPriceFlag(i);
    }
  }

  get subContractorsCostsFormArray(): FormArray<FormGroup<SolEstimateTableRowBaseExtendedSubContractor>> {
    return this.subContractorsCostsFormGroup.controls.subContractorsCostsRow;
  }

  trackBySubContractorsCostsListIndex(index: number): number {
    return index;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
